import React, { createContext, useState } from "react";

const FaqContext = createContext();

const FaqProvider = ({ children }) => {
  const [faqId, setFaqId] = useState(0);
  const [isEditing, setIsEditing] = useState(false);
  const [refresh, setRefresh] = useState(false);
  
  return (
    <FaqContext.Provider
      value={{
        faqId,
        setFaqId,
        isEditing,
        setIsEditing,
        refresh,
        setRefresh,
      }}
    >
      {children}
    </FaqContext.Provider>
  );
};

export { FaqContext, FaqProvider };
